import anime from 'animejs';
import { View } from 'rune-ts';

export interface IVisibleController {
  setVisible(visible: boolean): void;
  isVisible(): boolean;
}

type DisplayOption = 'flex' | 'block' | 'inline-flex';

export class VisibleController {
  private visible: boolean;
  private display: DisplayOption;

  private view: View;
  private animation?: anime.AnimeInstance;

  constructor(view: View, visible: boolean, display?: DisplayOption) {
    this.view = view;
    this.visible = visible;
    this.display = display ?? 'block';
  }

  public isVisible(): boolean {
    return this.visible;
  }

  public setVisible(visible: boolean): this {
    this.visible = visible;
    this.syncVisible();
    return this;
  }

  private syncVisible(): void {
    if (this.animation) {
      this.animation.pause();
    }

    if (this.visible) {
      this.el.style.display = this.display;

      this.animation = anime({
        targets: this.el,
        height: [`0px`, `${this.el.scrollHeight}px`],
        marginBottom: '2rem',
        opacity: [0, 1],
        duration: 400,
        easing: 'easeInOutQuad',
        complete: () => {
          if (this.el) {
            this.el.style.height = 'auto';
          }
        },
      });
    } else {
      this.animation = anime({
        targets: this.el,
        height: [`${this.el.scrollHeight}px`, `0px`],
        opacity: [1, 0],
        marginBottom: '0',
        duration: 400,
        easing: 'easeInOutQuad',
        complete: () => {
          if (this.el) {
            this.el.style.display = 'none';
          }
        },
      });
    }
  }

  private get el() {
    return this.view.element();
  }
}
